// 英文语言包入口文件
import common from './common';
import navbar from './navbar';
import home from './home';
import campaign from './campaign';
import afterRelease from './afterRelease';
import billingAndPayments from './billingAndPayments';
import bindPayment from './bindPayment';
import campaignCreate from './campaignCreate';
import campaignDetail from './campaignDetail';
import campaignInfo from './campaignInfo';
import orderDetail from './orderDetail';
import coupon from './coupon';
import headChatBot from './headChatBot';
import headsDna from './headsDna';
import integrationGuide from './integrationGuide';
import onboarding from './onboarding';
import organizationProfile from './organizationProfile';
import payment from './payment';
import plan from './plan';
import reports from './reports';
import viralIdeas from './viralIdeas';
import components from './components';
import bookDemo from './bookDemo';
import createOrganization from './createOrganization';
import emailUnsubscribe from './emailUnsubscribe';

export default {
  common,
  navbar,
  home,
  campaign,
  afterRelease,
  billingAndPayments,
  bindPayment,
  campaignCreate,
  campaignDetail,
  campaignInfo,
  orderDetail,
  coupon,
  headChatBot,
  headsDna,
  integrationGuide,
  onboarding,
  organizationProfile,
  payment,
  plan,
  reports,
  viralIdeas,
  components,
  bookDemo,
  createOrganization,
  emailUnsubscribe,
};
